import React, { useState, useEffect } from "react";

import { Trans } from "react-i18next";
import {
  Icon,
  Callout,
  Tag
} from "@blueprintjs/core";
import { Cell, Column, ColumnHeaderCell, RowHeaderCell, Table2 } from "@blueprintjs/table";

import { authenticatedGetFetch, authenticatedPostFetch } from "../../../utils/AuthenticatedFetch";
import ServerSelect from "../../Structure/ServerSelector";


export default function Services(props) {
  const [services, setServices] = useState([]);
  const [srv, setSrv] = useState(undefined);

  useEffect(() => {
    authenticatedGetFetch("/services?srv="+(srv?.id || 0), (response) => setServices(response));
  }, [srv])

  return (
    <Callout title={<Trans>Services</Trans>} icon="tree">
      <Callout intent="primary">
        <Trans>summary of the status of the services installed on the server and used by the WiLix parking system</Trans>
      </Callout>

      <ServerSelect onSelect={(id, srv) => setSrv(srv) } />

      <Table2
        cellRendererDependencies={[services]}
        numRows={services.length}
        rowHeaderCellRenderer={(rowIndex) => <RowHeaderCell index={rowIndex} name={services[rowIndex]["id"]} />}
      >
        {/* name */}
        <Column
          id="name"
          cellRenderer={(rowIndex) => <Cell>{services[rowIndex]["name"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>service</Trans>} />}
        />

        {/* description */}
        <Column
          id="desc"
          cellRenderer={(rowIndex) => <Cell>{services[rowIndex]["description"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>description</Trans>} />}
        />

        {/* enabled */}
        <Column
          id="enabled"
          cellRenderer={(rowIndex) => <Cell>{services[rowIndex]["enabled"] ? <Icon icon="automatic-updates" intent="success" /> : <Icon icon="cross" intent="danger" />}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>enabled</Trans>} />}
        />

        {/* running */}
        <Column
          id="running"
          cellRenderer={(rowIndex) => <Cell>{services[rowIndex]["running"] ? <span><Icon icon="tick-circle" intent="success" /> <Trans>started</Trans> {services[rowIndex]["since"]}</span> : <Icon icon="cross" intent="danger" />}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>running</Trans>} />}
        />

        <Column
          id="action"
          cellRenderer={(rowIndex) => {
            return <Cell>
              <div className="flexbox-center">
                {services[rowIndex]["running"] && <Tag icon="stop" minimal={true}
                  interactive={true}
                  onClick={() => authenticatedPostFetch("/service/stop?srv="+(srv?.id || 0),
                    { service: services[rowIndex]["name"] },
                    () => authenticatedGetFetch("/services?srv="+(srv?.id || 0), (response) => setServices(response))
                  )} />}
                {services[rowIndex]["running"] && <Tag icon="refresh" minimal={true}
                  interactive={true}
                  onClick={() => authenticatedPostFetch("/service/restart?srv="+(srv?.id || 0),
                    { service: services[rowIndex]["name"] },
                    () => authenticatedGetFetch("/services?srv="+(srv?.id || 0), (response) => setServices(response))
                  )} />}

                {services[rowIndex]["running"] || <Tag icon="play" minimal={true}
                  interactive={true}
                  onClick={() => authenticatedPostFetch("/service/start?srv="+(srv?.id || 0),
                    { service: services[rowIndex]["name"] },
                    () => authenticatedGetFetch("/services?srv="+(srv?.id || 0), (response) => setServices(response))
                  )} />}
              </div>
            </Cell>
          }}
          columnHeaderCellRenderer={() => <ColumnHeaderCell />}
        />
      </Table2>
    </Callout>
  )
}
